import { useTranslation } from 'next-i18next/pages'
import { useMemo } from 'react'

import type { ChoiceCardVerticalPageProps } from 'components/GenderFunnel/ChoiceCardPage/ChoiceCardPage.Types'
import { ChoiceCardVerticalPage } from 'components/GenderFunnel/ChoiceCardPage/ChoiceCardVerticalPage'
import { useFunnelImages } from 'hooks/useImageProps'
import { DescriptionTerms } from 'sections/gender-funnel/WelcomeAgeBuckets/DescriptionTerms/DescriptionTerms'
import { usePage } from 'sections/gender-funnel/WelcomeAgeBuckets/usePage'
import { Question } from 'types/state'

type FunnelType = 'shared'

type Props = {
  funnel: FunnelType
}

export const BucketsPageVariant = ({ funnel }: Props) => {
  const { t } = useTranslation()
  const { getFunnelImageProps } = useFunnelImages(funnel)
  const pageProps = usePage(funnel)

  const options = useMemo<
    ChoiceCardVerticalPageProps<Question.AgeBucket, FunnelType>['options']
  >(() => {
    return [
      {
        title: t('welcome_age_buckets_option_18_29'),
        value: Question.AgeBucket.Age_18_29,
        imageProps: getFunnelImageProps(
          'welcomeAgeBuckets',
          'eighteenToTwentyNine'
        ),
      },
      {
        title: t('welcome_age_buckets_option_30_39'),
        value: Question.AgeBucket.Age_30_39,
        imageProps: getFunnelImageProps(
          'welcomeAgeBuckets',
          'thirtyToThirtyNine'
        ),
      },
      {
        title: t('welcome_age_buckets_option_40_49'),
        value: Question.AgeBucket.Age_40_49,
        imageProps: getFunnelImageProps(
          'welcomeAgeBuckets',
          'fortyToFortyNine'
        ),
      },
      {
        title: t('welcome_age_buckets_option_50_plus'),
        value: Question.AgeBucket.Age_50_plus,
        imageProps: getFunnelImageProps('welcomeAgeBuckets', 'fiftyPlus'),
      },
    ]
  }, [getFunnelImageProps, t])

  return (
    <ChoiceCardVerticalPage<Question.AgeBucket, FunnelType>
      {...pageProps}
      funnel={funnel}
      options={options}
      variant="blue2"
    >
      <DescriptionTerms />
    </ChoiceCardVerticalPage>
  )
}
